// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_2Mn7FtSnN2knHduRNP2xMz","checked":"_2xdcPnP_FMV0jVDdbt1OZJ","disabled":"_2t1yjyz05QWuBJLP80Q3WT","icon":"_7YT2k0kZCMgnyFlKWyARo"};